import React from 'react';

import './DemoModePanel.less';

export const DEMO_MODE_PANEL_HEIGHT = '28px';

export default function DemoModePanel() {
  return (
    <div className="demo-mode-panel" style={{ height: DEMO_MODE_PANEL_HEIGHT }}>
      <p>
        <strong style={{ whiteSpace: 'nowrap' }}>Learning mode.</strong>
      </p>
      <p>Explore freely — nothing you do here will be saved.</p>
    </div>
  );
}
